<style>
@import '../../custom/css/rejeitadas.css';
</style>

<template>
  <div class="rejeitadas" id="perdidas">
    <div class="row m-0" v-if="cotacoes !== []">
      <div class="col-12 my-4" id="inicio">
        <h1
          class="title font-weight-bold text-uppercase d-flex justify-content-center"
        >
          Orçamentos Perdidos
        </h1>
      </div>
      <div
        class="col-lg-4 col-md-6"
        v-for="(cotacao, index) in cotacoes"
        :key="index"
      >
        <div class="card-cotacao">
          <div class="cc-header d-flex">
            <div class="cc-sub-title m-r-25">
              <img
                class="imagem-archive-cotacao"
                src="@/assets/img/icons/file-archive.png"
                alt="Ícone para representar a cotação"
              />
            </div>
            <div class="cc-sub-title">
              <div>
                Data:
                <div class="cc-sub-result">{{ cotacao.criado_em }}</div>
              </div>
              <div>
                Cód:
                <div class="cc-sub-result">{{ cotacao.cot_cotacao_id }}</div>
              </div>
            </div>
          </div>
          <div class="cc-footer">
            <div
              class="btn-ver-cotacao"
              @click="verCotacao(cotacao.cot_cotacao_id, dadosUsuario.id)"
            >
              Ver Cotação
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import scrollToElement from '../../mixins/scrollToElement';

export default {
  mixins:[scrollToElement],
  name: 'perdidas',
  computed: {
    ...mapGetters([
      // Mapeamento de getters
    ]),
    ...mapState({
      // Mapeamento de states
      token: (state) => state.token,
      dadosUsuario: (state) => state.dadosUsuario,
      cotacoes: (state) => state.cotacoes,
    }),
  },
  mounted(){
    this.scrollToElement();
  },
  created() {
    this.scrollToElement();
    const self = this;

    if (this.checkIsEmpty(this.dadosUsuario)) {
      this.$router.push({ name: 'area-restrita' });
    }

    this.$store.dispatch('emptyCotacoes').then(() => {
      this.$store.dispatch('startLoader');
      setTimeout(() => {
        self.$store
          .dispatch('showCotacoesUsuarioPerdidas', this.dadosUsuario.id)
          .then(() => {
            setTimeout(() => {
              self.$store.dispatch('endLoader');
            }, 1000);
          })
          .catch(() => {
            setTimeout(() => {
              self.$store
                .dispatch('showCotacoesUsuarioPerdidas', this.dadosUsuario.id)
                .then(() => {
                  setTimeout(() => {
                    self.$store.dispatch('endLoader');
                  }, 1000);
                })
                .catch(() => {
                  self.$store.dispatch('endLoader');
                  self.aviso(
                    'Não foi possível carregar as cotações! Tente novamente em 5 minutos!',
                    'danger'
                  );
                });
            }, 1000);
          });
      }, 1000);
    });
  },
  methods: {
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
    verCotacao(cot_id, usu_id) {
      if (!this.checkIsEmpty(cot_id) && !this.checkIsEmpty(usu_id)) {
        this.$router.push({
          name: 'lojista-cotacao-perdida',
          params: {
            cot_id,
            usu_id,
          },
        });
      }
    },
  },
};
</script>
